module.exports = __webpack_public_path__ + "static/media/payment-method.722e2865.png";